import { useEffect, useState } from "react";
import { NavLink, redirect, useParams, Link } from 'react-router-dom'
import './sidebar.css'
import context from '../../scripts/context'

const Sidebar = ({ closeSidebar, extraClass, showSidebar, privileges }) => {
    const [Redirect, setRedirect] = useState('')
    const [show, setShow] = useState(false)
    const [nav, setNav] = useState([
        // {
        //     label: 'Profile',
        //     icon: '',
        //     url: '/agent/profile',
        //     expandable: false,
        //     accessible: (privileges.includes())
        // },
        {
            label: 'Office Management',
            icon: '',
            url: '/agent/offices',
            expandable: false,
            accessible: (privileges.includes('LIST_OFFICE')? true : false)
        },
        {
            label: 'User Management',
            icon: '',
            url: '/agent/users',
            expandable: false,
            accessible: (privileges.includes('LIST_USER')? true : false)
        },
        {
            label: 'Role Management',
            icon: '',
            url: '/agent/roles',
            expandable: false,
            accessible: (privileges.includes('LIST_ROLE'))
        },
        {
            label: 'Payment Management',
            icon: '',
            url: '/agent/payments',
            expandable: false,
            accessible: (privileges.includes('LIST_TRANSACTION'))

        },
        // {
        //     label: 'Calculator',
        //     icon: '',
        //     url: '/agent/calculator',
        //     expandable: false,
        //     accessible: (privileges.includes('CALC_EXCESS'))
        // }
    ])

    const logout = () => {
        window.localStorage.clear()
        context.setIsLoggedIn(false)
        console.log('miai too login')
    }

    if(Redirect) return <redirect to={Redirect} />


    return (
        <div className={'sidebar-container ' + extraClass + (showSidebar ? ' active' : '')}>
            <div className="sidebar-container__background" onClick={closeSidebar}></div>
            <div className="sidebar">
                <div className="logo-container">
                    <img src="/images/tahagasht-h-w.svg" />
                </div>
                
                <div className="sidebar__close">
                    <i className="icon-Close" onClick={closeSidebar}></i>
                </div>
                <Link className="sidebar__header">
                    <div className="name">
                        <span className="s1">{window.localStorage.getItem('name')}</span>
                        <span className="s2">{window.localStorage.getItem('office')}</span>
                    </div>
                </Link>
                <Link className="change-password" to={'/agent/chpass'}> Change Password</Link>
                
                <div className="line"></div>
                <div className="sidebar__menu">

                    {nav.map((navItem, index) =>

                        
                            navItem.accessible == true &&
                            <NavLink to={navItem.url} exact activeClassName="selected" className={(navItem.accessible ? 'menu-item' : 'newItem')} onClick={closeSidebar} key={"side"+index}>
                                <div className="menu-item__icon">
                                    <i className={navItem.icon}></i>
                                </div>
                                <div className="menu-item__label">{navItem.label}</div>
                                <i className="icon-Arrow---Left-2"></i>
                            </NavLink>
                        
                    )}



                    <div className="menu-item exit" onClick={logout}>
                        <div className="menu-item__icon">
                            <i className="icon-Export"></i>
                        </div>
                        <Link to={'/agent/login'} className="menu-item__logout">Logout</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar


